<template>
  <!--
    作者：kmdshop
    时间：2020-06-04
    描述：插件中心-积分商城
  -->
  <div>
    <!--好友圈列表-->
    <Friends v-if="activeName == 'friends'"></Friends>

    <!--好友圈设置-->
    <Settings v-if="activeName == 'settings'"></Settings>
  </div>
</template>
<script>
import bus from '@/utils/eventBus.js';
import Friends from './friends';
import Settings from './setting';

export default {
  components: {
    Friends,
    Settings,
  },
  data() {
    return {
      /*参数*/
      param: {},
      /*当前选中*/
      activeName: 'friends',
      /*切换数组原始数据*/
      sourceList: [
        {
          key: 'friends',
          value: '好友圈列表',
          path:'/plus/friends/friends'
        },
        {
          key: 'settings',
          value: '好友圈设置',
          path:'/plus/friends/setting'
        }
      ],
      /*权限筛选后的数据*/
      tabList:[],
    };
  },
  created() {

    this.tabList=this.authFilter();
    
    if(this.tabList.length>0){
      this.activeName=this.tabList[0].key;
    }

    if (this.$route.query.type != null) {
      this.activeName = this.$route.query.type;
    }

    /*监听传插件的值*/
    bus.$on('activeValue', res => {
      this.activeName = res;
    });

    //发送类别切换
    let params = {
      active: this.activeName,
      list: this.tabList,
      tab_type: 'storage'
    };
    bus.$emit('tabData', params);
  },
  beforeDestroy() {
    //发送类别切换
    bus.$emit('tabData', { active: null, tab_type: 'storage', list: [] });
    bus.$off('activeValue');
  },
  methods: {

    /*权限过滤*/
    authFilter(){
      let list=[];
      for(let i=0;i<this.sourceList.length;i++){
        let item=this.sourceList[i];
        if(this.$filter.isAuth(item.path)){
          list.push(item);
        }
      }
      return list;
    },

  }
};
</script>



// WEBPACK FOOTER //
// src/views/plus/friends/index.vue